import { defineMessages } from 'react-intl';

export const ContactProfileMessages = defineMessages({
  telephone: {
    id: 'block.contactprofile.telephone',
    defaultMessage: 'Telephone',
  },
  telephone_reception: {
    id: 'block.contactprofile.telephone_reception',
    defaultMessage: '(reception)',
  },
  telephone_direct: {
    id: 'block.contactprofile.telephone_direct',
    defaultMessage: '(direct)',
  },
  email: {
    id: 'block.contactprofile.email',
    defaultMessage: 'email',
  },
});
